var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.renderLab)?_vm._t("default"):_vm._e(),(_vm.showDialog)?_c('not-compatible-browser',{attrs:{"error-type":_vm.errorType},on:{"close":function($event){_vm.showDialog = false}}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }